<template>
  <div class="pay-success-page">
    <!-- 支付成功区域 -->
    <div class="success-section">
      <img class="success-icon" src="/images/lvyouxian/pay-success-icon.png" alt="支付成功" />
      <h1 class="success-title">支付成功！</h1>
      <span class="order-code">订单号：{{ $route.query.orderCode }}</span>
      <p class="success-subtitle">感谢您的信任，平安行将守护您的旅程。</p>
    </div>

    <!-- 理赔极速指引 -->
    <div class="claim-guide-section">
      <h2 class="guide-title">理赔极速指引</h2>
      <img class="guide-steps" src="/images/lvyouxian/claim-guide-steps.png" alt="理赔步骤" />
    </div>

    <!-- 查询保单按钮 -->
    <div class="action-section">
      <v-btn
        class="query-policy-btn"
        color="#dd122a"
        dark
        @click="queryPolicy"
      >
        查询保单
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaySuccess',
  data() {
    return {};
  },
  methods: {
    queryPolicy() {
      const certNo = this.$route.query.certNo;
      this.$router.push({
        path: '/product/new/detail/travelInsurance/policyInquiry',
        query: { certNo }
      });
    }
  },
  mounted() {
    // 投保成功页面，不需要录制
  }
};
</script>

<style lang="scss" scoped>
.pay-success-page {
  background-color: #f5f5f5;
  padding: 60px 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 支付成功区域 */
.success-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  .order-code {
    font-size: 16px;
    color: #333;
    margin-bottom: 16px;
  }
  .success-icon {
    width: 138px;
    height: 138px;
    margin-bottom: 38px;
  }

  .success-title {
    font-size: 38px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 16px;
  }

  .success-subtitle {
    font-size: 16px;
    color: #999;
  }
}

/* 理赔极速指引 */
.claim-guide-section {
  width: 100%;
  max-width: 1200px;
  background-color: #fff;
  border-radius: 16px;
  padding: 32px 70px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

  .guide-title {
    font-size: 28px;
    font-weight: 500;
    color: #262626;
    text-align: center;
    margin-bottom: 45px;
  }

  .guide-steps {
    width: 100%;
    display: block;
  }
}

/* 查询保单按钮 */
.action-section {
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: center;
  margin-top: 30px;

  .query-policy-btn {
    width: 200px;
    height: 44px;
    font-size: 16px;
    border-radius: 22px;
    text-transform: none;
  }
}
</style>
